import { render, staticRenderFns } from "./lkuCustomers.vue?vue&type=template&id=18b7e89f"
import script from "./lkuCustomers.vue?vue&type=script&lang=js"
export * from "./lkuCustomers.vue?vue&type=script&lang=js"
import style0 from "./lkuCustomers.vue?vue&type=style&index=0&id=18b7e89f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports